import { render, staticRenderFns } from "./events-table.vue?vue&type=template&id=4c5b5d96"
import script from "./events-table.vue?vue&type=script&lang=ts"
export * from "./events-table.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports